import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import Loader from '../../Loader';

/**
 * @param {import('react').ButtonHTMLAttributes<HTMLButtonElement> & {
 *  innerRef?: React.RefObject<HTMLButtonElement>
 *  variant?: import('utils/types').ButtonVariant
 *  size: import('utils/types').Size
 *  spinnerSize: import('utils/types').Size
 *  disabled?: boolean
 *  processing?: boolean
 *  processingText?: string
 *  className?: string
 * }} props
 */
export default function Button({
  innerRef = null,
  variant = 'primary',
  size = 'md',
  spinnerSize = 'md',
  disabled = false,
  processing = false,
  processingText = '',
  className = '',
  children = null,
  ...htmlProps
}) {
  return (
    <button
      {...htmlProps}
      ref={innerRef}
      disabled={disabled || processing}
      aria-busy={processing}
      data-processing={!!processing}
      className={cn(
        styles.button,
        styles[variant],
        styles[`size-${size}`],
        className,
      )}
    >
      <div className={styles.cell} aria-hidden={processing || undefined}>
        {children}
      </div>
      <div className={styles.cell} aria-hidden={!processing || undefined}>
        {processingText}
        <span className={styles.loader} aria-hidden="true">
          <Loader.Spinner size={spinnerSize} />
        </span>
      </div>
      <span className={styles.visuallyHidden} role="status">
        {processing ? processingText : ''}
      </span>
    </button>
  );
}
